import BasePage from "../../../../base/BasePage";
import React from "react";
import OtherInfoPresenter from "./OtherInfoPresenter";
import { addSchemaUseCase } from "../../../../usecases/schema/usecases";
import CardView from "../../../../components/common/CardView";
import DropDown from "../../../../components/common/DropDown";
import { formatDate } from "../../../../components/common/Converter";
import FileUpload from "../../../../components/common/FileUpload";

class OtherInfoPage extends BasePage {
  constructor(props) {
    super(props);
    this.presenter = new OtherInfoPresenter(this, addSchemaUseCase());
    this.state = {
      progress: false,
    };
  }

  showProgress() {
    this.setState({ progress: true });
  }

  hideProgress() {
    this.setState({ progress: false });
  }

  handlePreview(imageUrl) {
    window.open(imageUrl, "_blank");
  }

  dropDownContent(arrayItems, title) {
    let validItems = [];
    if (
      Array.isArray(arrayItems) &&
      arrayItems.length > 0 &&
      arrayItems.some((item) => item !== undefined)
    ) {
      validItems = arrayItems.filter(
        (item) => item !== undefined && item !== null
      );
    }

    return (
      <div className="d-grid gap-3">
        <FileUpload
          disabled={true}
          label={"View"}
          attachments={validItems}
          object={this.props.object}
        />
      </div>
    );
  }

  arrayValidation(arrayItem) {
    if (
      Array.isArray(arrayItem) &&
      arrayItem.length > 0 &&
      arrayItem.some((item) => item !== undefined)
    ) {
      return arrayItem.length;
    } else {
      return 0;
    }
  }

  render() {
    const tableData = (thead, tbody) => {
      return (
        <tr className="row">
          <th className="col-lg-4 pb-2">{thead}</th>
          <td className="col-lg-8 pb-2">{tbody}</td>
        </tr>
      );
    };

    const containerStyle = {
      color: "#333",
      borderBottom: "1px solid #ccc",
      display: "flex",
      paddingLeft: "1.5rem",
      paddingTop: "1rem",
      paddingBottom: "1rem",
      alignItems: "center",
    };

    const {
      voluntaryWorkBackground,
      learningDevBackground,
      civilServiceBackground,
      otherInformationBackground,
      filterCommittee,
    } = this.props;

    const empID = this.getCurrentUser().employee.id;

    const formatTitle = (title) => {
      return title
        .replace(/([A-Z])/g, " $1") // Adds space before capital letters
        .replace(/^./, (str) => str.toUpperCase()) // Capitalizes the first letter
        .trim(); // Removes any leading or trailing spaces
    };

    const dropdownFields = [
      { field: "personalDataSheet", title: "personalDataSheet" },
      { field: "appointment", title: "appointment" },
      { field: "positionDescriptionFrom", title: "positionDescriptionFrom" },
      { field: "oathOfOffice", title: "oathOfOffice" },
      { field: "serviceRecord", title: "serviceRecord" },
      { field: "AssumptionOfDuty", title: "AssumptionOfDuty" },
      { field: "contractOfService", title: "contractOfService" },
      {
        field: "copiesOfCertificatedEligibilities",
        title: "copiesOfCertificatedEligibilities",
      },
      { field: "copiesOfDiploma", title: "copiesOfDiploma" },
      { field: "copyOfBirth", title: "copyOfBirth" },
      { field: "medicalCertificated", title: "medicalCertificated" },
      { field: "nbiClearance", title: "nbiClearance" },
      {
        field: "NoticeOfSalaryAdjustments",
        title: "NoticeOfSalaryAdjustments",
      },
      { field: "personalOrders", title: "personalOrders" },
      { field: "letterDirective", title: "letterDirective" },
      { field: "travelOrders", title: "travelOrders" },
      {
        field: "copiesOfDisciplinaryActions",
        title: "copiesOfDisciplinaryActions",
      },
      { field: "individualPerformance", title: "individualPerformance" },
      { field: "swornStatementOfAssets", title: "swornStatementOfAssets" },
      { field: "othersFile", title: "othersFile" },
    ];

    const dropdowns = dropdownFields.map(({ field, title }) => ({
      title: `${formatTitle(title)} (${this.arrayValidation(
        this.props[field]
      )})`,
      content: this.dropDownContent(this.props[field], title),
    }));
    return (
      <>
        <div
          className="row m-auto w-100 h-100 mb-2"
          style={{ height: "300px" }}
        >
          <div className="col-lg-6" style={{ padding: "0  5px 0 5px" }}>
            <div className="mb-3" style={{ height: "auto" }}>
              <CardView
                style={{
                  padding: 0,
                  borderRadius: 0,
                }}
              >
                <div style={containerStyle}>
                  <p style={{ margin: 0 }}>Family Background</p>
                </div>
                <div
                  className=""
                  style={{
                    paddingLeft: "1.5rem",
                    paddingTop: "1rem",
                    fontSize: "13px",
                  }}
                >
                  <h6>Spouse</h6>
                  <hr />
                  <table className="w-75">
                    {tableData("Name: ", this.props.spouseName)}
                    {tableData("Occupation: ", this.props.spouseoccupation)}
                    {tableData("Employer Name: ", this.props.spouseemployer)}
                    {tableData("Business Address: ", this.props.spouseaddress)}
                    {tableData("Telephone No.: ", this.props.spousetelNo)}
                    <h6 className="border-bottom">Father</h6>
                    {tableData("Name: ", this.props.fatherName)}
                    <h6 className="border-bottom">Mother</h6>
                    {tableData("Name: ", this.props.motherName)}
                  </table>
                </div>
              </CardView>
            </div>
            <div className="mb-3" style={{ height: "auto" }}>
              <CardView
                style={{
                  padding: 0,
                  borderRadius: 0,
                }}
              >
                <div style={containerStyle}>
                  <p style={{ margin: 0 }}>Civil Service Eligibility</p>
                </div>
                <div
                  className=""
                  style={{
                    paddingLeft: "1.5rem",
                    paddingTop: "1rem",
                    fontSize: "13px",
                  }}
                >
                  {civilServiceBackground.map((civilService, index) => (
                    <table className="w-75" key={index}>
                      {tableData(
                        "Career Service: ",
                        civilService?.civilCareer || "-"
                      )}
                      {tableData("Rating: ", civilService?.civilRating || "-")}
                      {tableData(
                        "Date of Examination/Conferment: ",
                        formatDate(civilService?.civilExamination) || "-"
                      )}
                      {tableData(
                        "Place of Examination/Conferment: ",
                        civilService?.civilPlace || "-"
                      )}
                      {tableData(
                        "License Number: ",
                        civilService?.civilLicense || "-"
                      )}
                      {tableData(
                        "Date of Validity: ",
                        formatDate(civilService?.civilValidity) || "-"
                      )}
                      <hr />
                    </table>
                  ))}
                </div>
              </CardView>
            </div>
          </div>
          <div className="col-lg-6" style={{ padding: "0  5px 0 5px" }}>
            <div className="mb-3" style={{ height: "auto" }}>
              <CardView
                style={{
                  padding: 0,
                  borderRadius: 0,
                }}
              >
                <div style={containerStyle}>
                  <p style={{ margin: 0 }}>Voluntary Work</p>
                </div>
                <div
                  style={{
                    paddingLeft: "1.5rem",
                    paddingTop: "1rem",
                    fontSize: "13px",
                  }}
                >
                  {voluntaryWorkBackground.map((voluntaryWork, index) => (
                    <table className="w-75" key={index}>
                      {tableData(
                        "Name & Address of Organization: ",
                        voluntaryWork?.voluntaryOrganization || "-"
                      )}
                      {tableData(
                        "Position/Nature of Work: ",
                        voluntaryWork?.voluntaryPosition || "-"
                      )}
                      {tableData(
                        "Number of Hours: ",
                        voluntaryWork?.voluntaryHours || "-"
                      )}
                      {tableData(
                        "Inclusive Dates: ",
                        `${formatDate(
                          voluntaryWork?.voluntaryFrom
                        )} - ${formatDate(voluntaryWork?.voluntaryTo)}`
                      )}
                      <hr />
                    </table>
                  ))}
                </div>
              </CardView>
            </div>
            <div className="mb-3" style={{ height: "auto" }}>
              <CardView
                style={{
                  padding: 0,
                  borderRadius: 0,
                }}
              >
                <div style={containerStyle}>
                  <p
                    style={{
                      margin: 0,
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                    }}
                  >
                    Learning and Development(L&D) Interventions/Training
                    Programs Attended
                  </p>
                </div>
                <div
                  className=""
                  style={{
                    paddingLeft: "1.5rem",
                    paddingTop: "1rem",
                    fontSize: "13px",
                  }}
                >
                  {learningDevBackground.map((learningDev, index) => (
                    <table className="w-75" key={index}>
                      {tableData(
                        "Trainings/Programs: ",
                        learningDev?.learningTitle || "-"
                      )}
                      {tableData(
                        "Type of LD: ",
                        learningDev?.learningType || "-"
                      )}
                      {tableData(
                        "Number of Hours: ",
                        learningDev?.learningHours || "-"
                      )}
                      {tableData(
                        "Conducted/Sponsored By: ",
                        learningDev?.learningConducted || "-"
                      )}
                      {tableData(
                        "Date From: ",
                        formatDate(learningDev?.learningFrom)
                      )}
                      {tableData(
                        "Date To: ",
                        formatDate(learningDev?.learningTo)
                      )}
                      <hr />
                    </table>
                  ))}
                </div>
              </CardView>
            </div>
          </div>
          <div className="col-lg-6" style={{ padding: "0  5px 0 5px" }}>
            <div className="mb-3" style={{ height: "auto" }}>
              <CardView
                style={{
                  padding: 0,
                  borderRadius: 0,
                }}
              >
                <div style={containerStyle}>
                  <p style={{ margin: 0 }}>Other Information</p>
                </div>
                <div
                  className=""
                  style={{
                    paddingLeft: "1.5rem",
                    paddingTop: "1rem",
                    fontSize: "13px",
                  }}
                >
                  {otherInformationBackground.map((otherInfo, index) => (
                    <table className="w-75" key={index}>
                      {tableData(
                        "Special skills and Hobbies: ",
                        otherInfo?.specialSkills || "-"
                      )}
                      {tableData(
                        "Non-academic distinctions/Recognition: ",
                        otherInfo?.recognition || "-"
                      )}
                      {tableData(
                        "Membership in association/Organization: ",
                        otherInfo?.membership || "-"
                      )}
                      <hr />
                    </table>
                  ))}
                </div>
              </CardView>
            </div>
          </div>
          <div className="col-lg-6" style={{ padding: "0  5px 0 5px" }}>
            <div className="mb-3" style={{ height: "auto" }}>
              <CardView
                style={{
                  padding: 0,
                  borderRadius: 0,
                }}
              >
                <div style={containerStyle}>
                  <p style={{ margin: 0 }}>Committee Structure</p>
                </div>
                <div
                  className=""
                  style={{
                    paddingLeft: "1.5rem",
                    paddingTop: "1rem",
                    fontSize: "13px",
                  }}
                >
                  <table className="w-75">
                    {filterCommittee?.length > 0 &&
                      filterCommittee.map((item) => {
                        const designation = item.committeeRelation.find(
                          (item) => item.employee.id === empID
                        );
                        console.log("designation: ", designation);
                        return (
                          <>
                            {tableData(
                              "Committee: ",
                              item?.committeeName || "-"
                            )}
                            {tableData(
                              "Designation: ",
                              designation?.Designation?.name || "-"
                            )}
                          </>
                        );
                      })}

                    {/* {tableData(
                      "Designation: ",
                      filterDisignation[0]?.designation?.name || "-"
                    )} */}
                  </table>
                </div>
              </CardView>
            </div>
          </div>
          <div className="col-lg-6" style={{ padding: "0 5px 0 5px" }}>
            <div className="mb-3">
              <CardView
                style={{
                  padding: 0,
                  borderRadius: 0,
                }}
              >
                <div style={containerStyle}>
                  <p style={{ margin: 0 }}>Attachments</p>
                </div>
                <div
                  className=""
                  style={{
                    padding: "1rem",
                    fontSize: "13px",
                  }}
                >
                  <DropDown dropdowns={dropdowns} />
                </div>
              </CardView>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default OtherInfoPage;
